document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.w-tl').forEach(initTimeline);
  });
  
  function initTimeline(section) {
    const cfgInput = section.querySelector('.w-tl__cfg');
    try {
      const cfg = JSON.parse(cfgInput?.value || '{}');
      if (cfg.accent) section.style.setProperty('--w-tl-accent', cfg.accent);
      if (cfg.neutral) section.style.setProperty('--w-tl-neutral', cfg.neutral);
    } catch(e){}
  
    const stepsWrap = section.querySelector('[data-w-tl-steps]');
    const track = section.querySelector('.w-tl__track');
    const fill = section.querySelector('.w-tl__fill');
    if (!stepsWrap || !track || !fill) return;
  
    let bounds = null;
    let stepData = [];
    let dotData = [];
  
    function measure() {
      const stepsRect = stepsWrap.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
    
      const sTop = window.scrollY + stepsRect.top; 
      const tTop = window.scrollY + trackRect.top; 
      const tHeight = trackRect.height;
    
      bounds = { sTop, tTop, tHeight };
    
      track.querySelectorAll('.w-tl__dot').forEach(el => el.remove());
      const steps = Array.from(stepsWrap.querySelectorAll('.w-tl__step'));
    
      const centers = steps.map(step => {
        const badge = step.querySelector('.w-tl__badge');
        if (badge) {
          const br = badge.getBoundingClientRect();
          return window.scrollY + br.top + br.height / 2;
        } else {
          const sr = step.getBoundingClientRect();
          return window.scrollY + sr.top;
        }
      });
    
      const first = Math.min(...centers);
      const last  = Math.max(...centers);
      const railTop    = Math.max(0, first - tTop);
      const railHeight = Math.max(0, Math.min(tHeight, last - first));
    
      track.style.setProperty('--rail-top',    railTop + 'px');
      track.style.setProperty('--rail-height', railHeight + 'px');
    
      stepData = [];
      dotData  = [];
    
      centers.forEach((centerPage, i) => {
        const offsetPx = centerPage - first; 
        const topInTrack = railTop + offsetPx;  
    
        const dot = document.createElement('span');
        dot.className = 'w-tl__dot';
        dot.style.top = `${topInTrack}px`;
        track.appendChild(dot);
    
        stepData.push({ step: steps[i], offsetPx });
        dotData.push({ dot, topInTrack });
      });
    
      fill.style.top = railTop + 'px';
    
      update();
    }
    
    function update() {
      if (!bounds) return;
    
      const stepsRect = stepsWrap.getBoundingClientRect();
      const sTop = window.scrollY + stepsRect.top;
      const sBottom = sTop + stepsRect.height;
    
      const VIEWPORT_ANCHOR = 0.55;
      const START_PAD = 0.00;
      const END_PAD   = 0.10;
    
      const viewAnchor = window.scrollY + window.innerHeight * VIEWPORT_ANCHOR;
      const start = sTop + window.innerHeight * START_PAD;
      const end   = sBottom - window.innerHeight * END_PAD;
    
      const SCROLL_STRETCH = 1;
    
      const railHeight = parseFloat(getComputedStyle(track).getPropertyValue('--rail-height')) || 0;
    
      const progress = Math.max(0, Math.min(1, (viewAnchor - start) / ((end - start) * SCROLL_STRETCH)));
      const fillPx   = progress * railHeight;
    
      fill.style.height = fillPx + 'px';
    
      stepData.forEach(s => {
        const passed = s.offsetPx <= fillPx;
        s.step.classList.toggle('is-passed', passed);
      });
    
      dotData.forEach(d => {
        const passed = (d.topInTrack - parseFloat(getComputedStyle(track).getPropertyValue('--rail-top'))) <= fillPx;
        d.dot.classList.toggle('is-passed', passed);
      });
    }
    
  
    const ro = new ResizeObserver(measure);
    ro.observe(stepsWrap);
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', update, { passive: true });
  
    measure();
    setTimeout(measure, 0);
    window.addEventListener('load', measure);
  }
  